import sales from '../../services/sales';
import account from '../../services/account';
import messageDialog from '../../components/message-dialog.vue'

export default {
  data() {
    return {
      taxpayerIdNumber: '',
      contactName: '',
      contactEmail: '',
      contactJobTitle: '', //TODO nao tem o campo TEL no SOA
      companyName: '',
      sizeOfFleetVehicle: '',
      formState: 'NEW',
      errorMessage: '',
      loading: undefined,
      leadClient: false
    }
  },
  computed: {

  },
  created() {
    let promo = this.$route.query.oferta;
    
    
    if (promo) {
      window.sessionStorage.setItem('promo', promo);
    }
  },
  mounted() {
  },

  methods: {
    doRequest() {
      let vm = this;
      vm.formState = 'NEW';
      try {

        vm.loading = vm.$validator.validateAll()
          .then(success => {
            let request = {
              lead: {
                taxpayerIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase(),
                contactName: vm.contactName,
                contactEmail: vm.contactEmail,
                phone: vm.contactJobTitle.replace(/[^\d]+/g, ''),
                companyName: vm.companyName,
                sizeOfFleetVehicle: vm.sizeOfFleetVehicle,
                "source": window.document.webview ? "MOBILE" : "WEBSITE",
              }
            };

            let promo = window.sessionStorage.getItem('promo');
            if (promo)
              request.lead.campaign = promo;

            if (this.$route.query.plano)
              request.lead.plan = this.$route.query.plano;

            let taxpayerIdNumber = vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
            let proposal = '';
            let promises = [];
            promises.push(sales.getLead({ taxpayerIdNumber, proposal }));
            promises.push(account.accountExists({ taxIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase() }));

            return Promise.all(promises).then(response => {

              


              let statusProposal = ['TRIAGEM', 'PROSPECÇÃO'];


              if (response[0].proposal && statusProposal.includes(response[0].proposal.listProposalStatus[0].status)) {
                vm.formState = 'LEAD-INFO';
                this.leadClient = !response[1];
                return Promise.resolve(true);
              }

              if (response[0].lead && response[0].proposal && response[0].proposal.listProposalStatus[0].status=='LEAD DESCARTADO'){
                request.lead.leadId = response[0].lead.leadId;

                let promise = [];
                request.createProcess = "";
                promise.push(sales.updateLead(request));
                let leadId = request.lead.leadId;
                promise.push(sales.createANewProposal({leadId}));

                return Promise.all(promise).then(response=>{
                  
                  vm.formState = 'SUCCESS';
                });
              }


              return sales.createLead(request)
                .then(data => {
                  if (data) vm.formState = 'SUCCESS';
                })
                .catch(err => {
                  vm.formState = 'ERROR';
                  vm.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
                });
            }).catch(err => {
            
            
          });
          }).catch(err => {
            
            
            vm.formState = 'ERROR';
            vm.errorMessage = 'Campos obrigatórios não foram preenchidos!';
          });
      } catch (e) {
        
        
      }
    },
  },

  components: {
  }
}



// WEBPACK FOOTER //
// ./src/pages/external/missing-company.js